export default __webpack_public_path__ + "static/media/mac_2.f9df3bf2.jpg";